<script>
import { defineComponent, h } from 'vue'

export default defineComponent({
  name: 'ObjectiveChartTableColorMark',
  props: {
    color: {
      type: String,
      required: true
    }
  },

  render() {
    return h('div', {
      class: 'ocm-Marker',
      style: { 'background-color': this.color }
    })
  }
})
</script>

<style lang="scss" scoped>
.ocm-Marker {
  height: var(--marker-size, 6px);
  width: var(--marker-size, 6px);
  border-radius: 50%;
}
</style>
